import React from 'react';
import { isXrplAddress } from '../utils/xrplOwner';

/**
 * Search input that doubles as a wallet-address filter.
 * Typing normal text performs the usual substring search (handled by the parent
 * via searchTerm). Pasting a valid XRPL address and pressing Enter (or clicking
 * "Search wallet") fetches that wallet's NFTs and filters the collection to them.
 */
const WalletSearchBox = ({ searchTerm, onSearchChange, wallet, placeholder }) => {
  const { isWalletSearch, walletAddress, loading, error, searchWallet, clearWallet } = wallet;
  const trimmed = searchTerm.trim();
  const looksLikeAddress = isXrplAddress(trimmed);

  const handleChange = (value) => {
    onSearchChange(value);
    // Editing the box after a wallet search reverts to normal substring search.
    if (isWalletSearch && value.trim() !== walletAddress) {
      clearWallet();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && looksLikeAddress && !loading) {
      searchWallet(trimmed);
    }
  };

  const showRow = looksLikeAddress || isWalletSearch || loading || error;

  return (
    <div className='search-box'>
      <input
        type='text'
        placeholder={placeholder || 'Search by name, trait, or paste a wallet address...'}
        value={searchTerm}
        onChange={(e) => handleChange(e.target.value)}
        onKeyDown={handleKeyDown}
        className='search-input'
      />
      {showRow && (
        <div className='wallet-search-row'>
          {looksLikeAddress && !isWalletSearch && (
            <button
              type='button'
              className='wallet-search-btn'
              onClick={() => searchWallet(trimmed)}
              disabled={loading}
            >
              {loading ? 'Searching…' : 'Search wallet'}
            </button>
          )}
          {isWalletSearch && (
            <button type='button' className='wallet-clear-btn' onClick={clearWallet}>
              Clear wallet filter
            </button>
          )}
          {loading && <span className='wallet-search-status loading'>Loading wallet NFTs…</span>}
          {error && <span className='wallet-search-status error'>{error}</span>}
          {isWalletSearch && !loading && !error && walletAddress && (
            <span className='wallet-search-status active'>
              Showing NFTs owned by {walletAddress.slice(0, 6)}…{walletAddress.slice(-4)}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default WalletSearchBox;
